import { SelectOption } from 'basics/options/options.types';
import { Presence } from 'generated/event.types';

const eventPresenceOptions: SelectOption[] = [
  { id: Presence.online, label: 'Online' },
];

export default eventPresenceOptions;
